import { env } from '$env/dynamic/public';

import { isLocal } from '$lib/build-info';

const DELAY_RAW = env['PUBLIC_DEV_DELAY'] || '300..1300';
const DELAY = /\.\./.test(DELAY_RAW)
	? (function parseDevDelayRange() {
			const [from, to] = DELAY_RAW.split('..', 2);
			return { from: parseInt(from), to: parseInt(to) };
		})()
	: (function parseDevDelayConstant() {
			const from = parseInt(DELAY_RAW);
			return { from, to: from };
		})();

if (isLocal) {
	console.debug('Dev. delay:', DELAY);
}

const delay = (ms: number) => new Promise((r) => setTimeout(r, ms));

/**
 * Wrap a promise so that in dev mode we wait an additional `ms` before
 * resolving. In production this is a no-op.
 */
export async function maybeDelay<T>(p: Promise<T>): Promise<T> {
	if (!isLocal) return p;
	// Random delay, between 300ms and 1300ms by default
	await delay(DELAY.from + Math.random() * (DELAY.to - DELAY.from));
	return p;
}

export default maybeDelay;
